import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import type { Rol } from '@/types/auth';

interface Props {
  /** Si se especifica, restringe a esos roles. Si no, basta con estar autenticado. */
  allowedRoles?: Rol[];
}

/**
 * Wrapper de ruta autenticada.
 *  - Sin sesión → /login (recordando hacia dónde iba).
 *  - Sesión pero sin rol permitido → /sin-permiso (página 403 amigable).
 */
export function ProtectedRoute({ allowedRoles }: Props) {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.rol)) {
    return <Navigate to="/sin-permiso" replace />;
  }

  return <Outlet />;
}
